import React from "react";
import { useSelector } from "react-redux";
import { Card, CardBody, CircularProgress } from "@nextui-org/react";
import { useTranslation } from "react-i18next";
import { BsDatabaseFill } from "react-icons/bs";

import LineChart from "../../../components/charts/LineChart";

const LineChartSection = ({ title, data }) => {
  const { t } = useTranslation();
  const { companies, loading_companies } = useSelector((state) => state.analytics.analytics);

  const company_grade = companies?.avg_grade?.toFixed(1);
  return (
    <div className="h-full flex flex-col">
      <div className="w-full 2xl:max-w-[480px] h-auto flex justify-between mb-4">
        <div className="flex flex-col">
          {!loading_companies ? (
            <h1 className="text-4xl text-primary font-semibold">
              {company_grade && company_grade !== "-1.0" ? companies?.avg_grade?.toFixed(1) : "N/A"}
            </h1>
          ) : (
            <p className="text-sm text-gray-300">{t("Loading...")}</p>
          )}
          <div className="flex items-center w-full space-x-2">
            <span className="text-[14px] text-gray-400 whitespace-nowrap">{t(title)}</span>
            {/* <IoMdArrowDropup className="w-4 h-4 text-success" /> */}
            {/* <span className=" text-success text-[12px] leading-3 font-medium">+2.45</span> */}
          </div>
          {/* <div className="text-success flex items-center space-x-2 mt-1">
                <IoIosCheckmarkCircle />
                <span className="text-xs font-semibold">{t("On track")}</span>
              </div> */}
        </div>
      </div>
      <div className="flex-1 w-full pt-4">
        {loading_companies && (
          <div className="flex flex-col justify-center items-center w-auto h-96 m-auto text-sm">
            <CircularProgress
              aria-label={t("Loading...")}
              color="primary"
              label={t("Loading...")}
            />
          </div>
        )}
        {!loading_companies && companies && companies?.avg_grade > -1 ? (
          <LineChart
            data={companies.grades}
            type="calls"
            title="Grades"
            minMaxAxisDiffFactor={0.01}
          />
        ) : !loading_companies && companies?.avg_grade === -1 ? (
          <div className="w-full h-full flex-1 flex flex-col items-center justify-center">
            <BsDatabaseFill className="text-gray-300 w-12 h-12" />
            <h3 className="text-sm text-gray-400 mt-3">{t("No records to display")}</h3>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default LineChartSection;
